/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_Filteroffers1Inputs */

const id_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter penawaran...`)
};

const ms_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapis tawaran...`)
};

const da_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrér tilbud...`)
};

const de_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote filtern...`)
};

const en_us2_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter offers...`)
};

const es_es2_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar ofertas...`)
};

const es_mx2_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar ofertas...`)
};

const fil_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-filter ang mga offer...`)
};

const fr_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer les offres…`)
};

const it_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra offerte...`)
};

const hu_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok szűrése...`)
};

const nl_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter aanbiedingen...`)
};

const no_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer tilbud...`)
};

const pl_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtruj oferty...`)
};

const pt_br2_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter offers...`)
};

const pt_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar ofertas...`)
};

const ro_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrează ofertele...`)
};

const fi_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suodata tarjouksia...`)
};

const sv_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrera erbjudanden...`)
};

const vi_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc ưu đãi...`)
};

const tr_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifleri filtrele...`)
};

const cs_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrovat nabídky...`)
};

const bg_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Филтриране на оферти...`)
};

const ru_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр предложений...`)
};

const uk_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фільтрувати пропозиції...`)
};

const ar_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفية العروض...`)
};

const hi_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र फ़िल्टर करें...`)
};

const th_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรองข้อเสนอ...`)
};

const ja_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーをフィルター...`)
};

const zh_cn2_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter offers...`)
};

const zh_hant1_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter offers...`)
};

const ko_table_toolbar_filteroffers1 = /** @type {(inputs: Table_Toolbar_Filteroffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter offers...`)
};

/**
* | output |
* | --- |
* | "Filter offers..." |
*
* @param {Table_Toolbar_Filteroffers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_filteroffers1 = /** @type {((inputs?: Table_Toolbar_Filteroffers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_Filteroffers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_filteroffers1(inputs)
	if (locale === "ms") return ms_table_toolbar_filteroffers1(inputs)
	if (locale === "da") return da_table_toolbar_filteroffers1(inputs)
	if (locale === "de") return de_table_toolbar_filteroffers1(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_filteroffers1(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_filteroffers1(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_filteroffers1(inputs)
	if (locale === "fil") return fil_table_toolbar_filteroffers1(inputs)
	if (locale === "fr") return fr_table_toolbar_filteroffers1(inputs)
	if (locale === "it") return it_table_toolbar_filteroffers1(inputs)
	if (locale === "hu") return hu_table_toolbar_filteroffers1(inputs)
	if (locale === "nl") return nl_table_toolbar_filteroffers1(inputs)
	if (locale === "no") return no_table_toolbar_filteroffers1(inputs)
	if (locale === "pl") return pl_table_toolbar_filteroffers1(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_filteroffers1(inputs)
	if (locale === "pt") return pt_table_toolbar_filteroffers1(inputs)
	if (locale === "ro") return ro_table_toolbar_filteroffers1(inputs)
	if (locale === "fi") return fi_table_toolbar_filteroffers1(inputs)
	if (locale === "sv") return sv_table_toolbar_filteroffers1(inputs)
	if (locale === "vi") return vi_table_toolbar_filteroffers1(inputs)
	if (locale === "tr") return tr_table_toolbar_filteroffers1(inputs)
	if (locale === "cs") return cs_table_toolbar_filteroffers1(inputs)
	if (locale === "bg") return bg_table_toolbar_filteroffers1(inputs)
	if (locale === "ru") return ru_table_toolbar_filteroffers1(inputs)
	if (locale === "uk") return uk_table_toolbar_filteroffers1(inputs)
	if (locale === "ar") return ar_table_toolbar_filteroffers1(inputs)
	if (locale === "hi") return hi_table_toolbar_filteroffers1(inputs)
	if (locale === "th") return th_table_toolbar_filteroffers1(inputs)
	if (locale === "ja") return ja_table_toolbar_filteroffers1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_filteroffers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_filteroffers1(inputs)
	return ko_table_toolbar_filteroffers1(inputs)
});
export { table_toolbar_filteroffers1 as "table.toolbar.filterOffers" }